import { z } from 'zod';

import { DateStringSchema, LocalDateTimeStringSchema, TimeStringSchema } from '../../common';
import { makeEndpoint } from '../common';

export const BulkCreateSchedulesRequestSchema = z.object({
  startDate: DateStringSchema,
  startTimes: z.array(TimeStringSchema),
  recurrencePattern: z
    .object({
      weekdays: z.array(z.number().min(1).max(7)),
      until: DateStringSchema,
    })
    .optional(),
  sessionDuration: z.number().min(1).int(),
});

export const BulkCreateSchedulesEndpoint = makeEndpoint({
  method: 'POST',
  url: ({
    brandId,
    resourceGroupCollectionId,
    resourceGroupId,
  }: {
    resourceGroupCollectionId: string;
    resourceGroupId: string;
    brandId: string;
  }) =>
    `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/resource-groups/${resourceGroupId}/schedules`,
  requestSchema: BulkCreateSchedulesRequestSchema.strict(),
  responseSchema: z.void(),
});

export const BulkDeleteSessionsRequestSchema = z.object({
  sessions: z.array(z.object({ startDateTime: LocalDateTimeStringSchema })),
});

export const BulkDeleteSessionsEndpoint = makeEndpoint({
  method: 'DELETE',
  url: ({
    brandId,
    resourceGroupCollectionId,
    resourceGroupId,
  }: {
    resourceGroupCollectionId: string;
    resourceGroupId: string;
    brandId: string;
  }) =>
    `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/resource-groups/${resourceGroupId}/sessions`,
  requestSchema: BulkDeleteSessionsRequestSchema.strict(),
  responseSchema: z.void(),
});
